export default {
    'shipping-advises': 'Shipping advises',
    'the-shipping-advice': 'the Shipping Advice?',
    'add-a-shipping-advice': 'Add a shipping advice',
    'shipping-advise': 'shipping advise',
    
    'item': 'item'
}